import {Service} from "@/apiServices/Service";

export class FacilidaPagoService extends Service{
    constructor() {
        super('facilidad/');
    }

    guardar(parametros) {
        return this.http.post(this.getUrl(['guardar']),parametros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRegistros() {
        return this.http.get(this.getUrl(['obtener']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    activarDesactivar(id) {
        return this.http.post(this.getUrl(['activarDesactivar']), id)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}